<template>
  <div v-show="show" class="wrap-pop">
    <div class="wrap-box">
      <h1>{{ $t("lang.Enroll") }}<i @click="close">+</i></h1>
      <div class="container"  :style="{'padding-top': !content ? '3rem' : ''}">
        <div v-html="content" class="content"></div>
        <b-form-group
          v-for="(item, index) in formfield"
          :key="index"
          id="fieldset-1"
          :label="item.name"
          label-for="input-1"
          :invalid-feedback="invalidFeedback"
          :state="state"
        >
          <b-form-input
            v-if="item.type == '1'"
            v-model="form[item.name]"
            :state="state"
            trim
          ></b-form-input>
          <b-form-textarea
            v-if="item.type == '2'"
            id="textarea-large"
            size="lg"
            v-model="form[item.name]"
            :state="state"
            :row="5"
            trim
          ></b-form-textarea>
        </b-form-group>
        <div v-show="fileName">{{ fileName }}</div>
        <div class="btns">
          <a href="javascript:;" class="a-upload mr-5">
            <input type="file" @change="fileChange($event)" name="" id="" />{{
              $t("lang.UploadResume")
            }}
          </a>
          <b-button type="submit" @click="submit">{{
            $t("lang.submit")
          }}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    invalidFeedback() {
      if (this.name.length > 0) {
        return "Enter at least 4 characters.";
      }
      return "";
    },
  },
  data() {
    return {
      content: "",
      fileName: "",
      name: "",
      state: null,
      formfield: [],
      type: "",
      form: {},
    };
  },
  created() {},
  watch: {
    $route: {
      handler(to) {
        this.type = to.query.volunteer;
        this.getMenu(this.type);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    close() {
      this.$emit("onclose");
    },
    upload() {},
    getMenu(type) {
      this.$forumApi
        .volunteerInfo({
          type: this.type,
        })
        .then((res) => {
          console.log(res.data);
          let arr = JSON.parse(res.data.menus);
          this.formfield = JSON.parse(res.data.menus);
          let keyArr = arr.map((item) => {
            return item.name;
          });
          keyArr.forEach((item) => {
            this.form[item] = "";
          });
          // console.log(this.form);
          this.content = res.data.content;
        });
    },
    submit() {
      if (this.form != null) {
        console.log("this.type", this.type);
        this.$forumApi
          .volunApplySave({
            type: this.type,
            tables: JSON.stringify(this.form),
          })
          .then((res) => {
            if (res.code == 200) {
              alert("提交成功");
            }
          });
      }
      console.log(this.form);
    },
    fileChange(e) {
      let file = e.target.files[0];
      let str = file.name;
      let arr = str.split(".");
      let formData = new FormData();
      formData.append("moduleName", "volunteer"); // 额外参数
      formData.append("fileUploads", e.file);
      this.$forumApi.uploadApi(formData).then((res) => {
        console.log("	uploadApi-----", res);
        if (res.code == 200) {
          this.fileName = str;
        }
      });
      // if (arr[arr.length - 1] == "doc" || arr[arr.length - 1] == "docx") {
      // }
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap-pop::v-deep {
  position: fixed;
  margin: auto;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: transparent;
  overflow-y: auto;
  z-index: 999999;

  .wrap-box {
    position: absolute;
    height: auto;
    width: 37vw;
    left: 0;
    top: 5rem;
    right: 0;
    margin: auto;
    margin-bottom: 2rem;
    box-shadow: 0 1px 15px rgb(18 21 21 / 20%);

    h1 {
      margin-bottom: 0 !important;
      line-height: 7rem;
      background: $forum-theme-blue;
      text-align: center;
      color: #ffffff;
      font-size: 1.2rem;
      font-weight: normal !important;

      i {
        position: absolute;
        display: block;
        top: 0;
        right: 0;
        font-size: 2.2rem;
        width: 2.2rem;
        height: 2.2rem;
        line-height: 2.2rem;
        cursor: pointer;
        transform: rotate(45deg);
      }
    }

    .container {
      font-size: 1rem;
      padding: 16px 5rem 1rem 5rem;
      background-color: #fff;

      .a-upload {
        height: 2.2rem;
        width: 10rem;
        line-height: 2.2rem;
        position: relative;
        text-align: center;
        color: #fff;
        background: $forum-theme-blue;
        border-radius: 0.2rem;
        display: inline-block;

        input {
          width: 100%;
          position: absolute;
          font-size: 100px;
          right: 0;
          top: 0;
          opacity: 0;
          filter: alpha(opacity=0);
          cursor: pointer;
        }
      }
    }
    .d-block {
      // color: red;
      font-size: 1rem;
      color: #717171;
    }
    .d-block::after {
      content: "*";
      display: inline-block;
      color: red;
      padding: 0px 2px;
    }
  }

  .btns {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    margin-top: 4rem;
  }

  .btn-secondary {
    width: 10rem;
    background-color: $forum-theme-blue;
    border: none;
  }
}
@media (min-width: 992px) {
  .wrap-box {
    width: 96vw;

    h1 {
      font-size: 1.3rem !important;
    }
  }
}
@media (max-width: 768px) {
  .wrap-box {
    width: 92vw !important;
    .container {
            padding: 16px 1rem 1rem 1rem!important;

    }
  }
}
</style>